import React, { useState } from "react";
import { BsPencil } from "react-icons/bs";
import { FaCircle, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { AddUserModal } from "./AddUserModal";
import { useNavigate } from "react-router-dom";
import { EditUserModal } from "./EditUserModal";
import NavigationButtons from "../../../../components/NavigationButtons";

const Users = () => {
  const navigate = useNavigate();
  const [buttonType, setButtonType] = useState("users");
  const [isAddUserModalOpen, setAddUserModalOpen] = useState(false);
  const [isEditUserModalOpen, setEditUserModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // Sample data for users
  const usersData = [
    {
      id: "1481",
      name: "M Usman",
      email: "usman@example.com",
      assignedRole: "Admin",
      status: "Active",
    },
    {
      id: "456",
      name: "Sarah Ali",
      email: "sarah@example.com",
      assignedRole: "Section Head",
      status: "Active",
    },
    {
      id: "1254",
      name: "Ahmad Ali",
      email: "ahmad@example.com",
      assignedRole: "Supervisor",
      status: "Active",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Active",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Active",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Inactive",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Active",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Active",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Active",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Active",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Inactive",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Active",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Active",
    },
    {
      id: "4212",
      name: "John Doe",
      email: "john@example.com",
      assignedRole: "School Head",
      status: "Active",
    },
  ];

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setEditUserModalOpen(true);
  };

  return (
    <div className="px-6">
      {/* <div className="flex items-center gap-8 mb-12">
        <Link to={"/admin/users"}>
        <button
          onClick={() => {setButtonType("users");
            
          }}
          className={`h-[40px] w-[180px] font-medium rounded-lg ${
            buttonType === "users"
              ? "border border-[#FF9348] bg-white text-[#FF9348]"
              : "bg-[#FF9348] text-white"
          } `}
        >
          Users
        </button>
        </Link>
        <Link to={"/admin/roles"}>
          <button
              onClick={() => {setButtonType("roles");
                
              }}
            className={`h-[40px] w-[180px] font-medium rounded-lg ${
              buttonType === "roles"
                ? "border border-[#FF9348] bg-white text-[#FF9348]"
                : "bg-[#FF9348] text-white"
            } `}
          >
           Roles
          </button>
        </Link>

        
      </div> */}
      <div className="flex items-center justify-end mb-2 mt-[-100px]">
    
        <div
          onClick={() => setAddUserModalOpen(true)}
          className="text-orange-400 border border-orange-400 p-2 rounded-lg hover:bg-orange-100 font-semibold flex items-center gap-2 cursor-pointer"
        >
          <FaPlus className="text-lg text-orange-400" />
          <button>Add User</button>
        </div>
      </div>
      <div className="bg-white border-gray-400 rounded-lg border w-full relative py-2 px-4">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="text-lg font-bold border-b border-gray-400">
              <tr>
                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                  ID
                </th>
                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                  Name
                </th>
                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                  Email
                </th>
                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                  Assigned Role
                </th>
                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                  Status
                </th>
                <th className="px-4 py-3 text-center text-gray-700 font-semibold">
                  Options
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-400">
              {usersData.map((user, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-3 whitespace-nowrap">{user.id}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{user.name}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{user.email}</td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    {user.assignedRole}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span
                      className={`inline-flex items-center px-3 py-1 rounded-md text-sm font-medium ${
                        user.status === "Active"
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      <FaCircle
                        className={`h-2 w-2 mr-2 ${
                          user.status === "Active"
                            ? "text-green-500"
                            : "text-red-500"
                        }`}
                      />
                      {user.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-center">
                    <button
                      className="px-3 py-1 bg-[#539BFF] text-white rounded-md flex items-center justify-center gap-1 hover:bg-blue-600 mx-auto"
                      onClick={() => handleEditClick(user)}
                      title="Edit User"
                    >
                      <BsPencil />
                      <span>Edit User</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
       
      </div>


      {isAddUserModalOpen && (
        <AddUserModal
          onClose={() => setAddUserModalOpen(false)}
          isOpen={isAddUserModalOpen}
        />
      )}

      {isEditUserModalOpen && selectedUser && (
        <EditUserModal
          onClose={() => setEditUserModalOpen(false)}
          isOpen={isEditUserModalOpen}
          userData={selectedUser}
        />
      )}
           <div className='mt-4'> 
              <NavigationButtons className="mt-4" />
              </div>
      
    </div>
  );
};

export default Users;
